/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum UserConfirmFailAliases {
  IMAGE_ERROR = 'image-error',
  LAYOUT_CONFIRMATION_FAIL = 'layout-confirmation-fail',
  LOGIN_IMAGE_HEADER = 'login-image-header',
  PANEL_CONTENT = 'panel-content',
  PANEL_IMAGE = 'panel-image',
  PANEL_LOGO = 'panel-logo',
  PANEL_SUB_TITLE = 'panel-sub-title',
  PANEL_TITLE = 'panel-title',
  TEXT_SUB_TITLE = 'text-sub-title',
  TEXT_TITLE = 'text-title',
}
export { UserConfirmFailAliases };
